export default Object.freeze({
    REFERRAL_SUBMITTED: 'REFERRAL_SUBMITTED',
    AWAITING_PROVIDER_PROPOSALS: 'AWAITING_PROVIDER_PROPOSALS',
    PROPOSALS_RECEIVED: 'PROPOSALS_RECEIVED',
    AWAITING_REFERRER_SELECTION: 'AWAITING_REFERRER_SELECTION',
    PENDING_PROVIDER_CONFIRMATION: 'PENDING_PROVIDER_CONFIRMATION',
    CONFIRMED: 'CONFIRMED',
    AWAITING_PATIENT_VISIT: 'AWAITING_PATIENT_VISIT',
    CANCELLED_NO_PROPOSALS: 'CANCELLED_NO_PROPOSALS',
    CANCELLED_NO_SELECTION: 'CANCELLED_NO_SELECTION',
    PROPOSALS_CLOSED: 'PROPOSALS_CLOSED',
    PROPOSE_TIME_SLOTS: 'PROPOSE_TIME_SLOTS',
    PROVIDER_DECLINED: 'PROVIDER_DECLINED',
    CLOSED: 'CLOSED',
    SELECT_A_TIME_SLOT: 'SELECT_A_TIME_SLOT',
    UPLOAD_RECORDS: 'UPLOAD_RECORDS',
    AWAITING_PROPOSALS: 'AWAITING_PROPOSALS',
})
